/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{342919CF-C890-4E9B-AA3B-0FEFAE0F95F1}",
  "sitecoreApiHost": "https://newsroom.lynkco.com",
  "jssAppName": "lynkco-global-portal",
  "webSettings": {
    "WebSiteHost": "https://newsroom.lynkco.com",
    "apiHost": "https://newsroom.lynkco.com",
    "apiKey": "725b4f36f44c45e68cc45b4b5632c9be",
    "apiHostGems": "https://lk-web-pd-api-1.azure-api.net/gemsapi",
    "apiHostTopicPack": "https://lynkco.dforigo.com/api/topicpack/feeds/webinfo/versions/production",
    "teamtailor": {
      "apiHost": "https://api.teamtailor.com",
      "apiKey": "MTt0Npaa3zGnSLuFbIfRp-FTv1-XkmNNc4A2lZbq",
      "apiVersion": "20161108"
    },
    "cookieId": "34CF2461-BA38-45CA-997C-ACCC1FC046CC",
    "o365ClientId": "9cb05c5f-b3e8-41e1-878c-e3abfc171938",
    "verificationCodeKey": "6LfPb-oUAAAAAN4a5sHHODDkZPnm1AzalpcJmYFo",
    "languages": [
      "en",
      "nl-nl",
      "fr-be",
      "nl-be",
      "fr-fr",
      "de-de",
      "it-it",
      "es-es",
      "sv-se"
    ],
    "countrys": {
      "en": "Global",
      "nl": "Netherlands",
      "be": "Belgium",
      "fr": "France",
      "de": "Germany",
      "it": "Italy",
      "se": "Sweden",
      "es": "Spain"
    },
    "chattooljs": "livechat_prod.js",
    "GTMID": "GTM-5XZ3KK5",
    "otherGTMID": "GTM-M63847H",
    "GAID": "G-PDLL350ZXX",
    "items": {
      "gender": "8E074F4D-DD4D-46B2-97B0-6A5C13DBA43C",
      "commentsCountries": "D40AF6C6-1655-40C5-8D96-7E337F5A92AB"
    }
  },
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/lynkco-global-portal",
  "graphQLEndpoint": "https://newsroom.lynkco.com/api/lynkco-global-portal?sc_apikey={342919CF-C890-4E9B-AA3B-0FEFAE0F95F1}"
};